import React, { useEffect, useState } from 'react';
import './services.scss'
export default function Services() {
  const [serviceList, setServiceList] = useState([]);
  useEffect(() => {
    setServiceList([
      { title: 'Experiencia de usuario', description: 'Interfaces fáciles de usar, flujos intuitivos combinados con modelos robustos que garantizan escalabilidad y mantenibilidad.' },
      { title: 'Orientación a resultados', description: 'Metodologías ágiles, métricas y foco en ROI para entregar soluciones que impulsan el negocio.' },
      { title: 'Consultoría estratégica y Product Management', description: 'Validación de idea, roadmap de producto y asesoría técnica para decisiones informadas.' },
      { title: 'Soporte técnico & Mantenimiento', description: 'SLA, monitoreo, parches y respuesta rápida para asegurar continuidad operativa.' },
      { title: 'DevOps, Infraestructura & Seguridad', description: 'CI/CD, cloud, observabilidad y prácticas de seguridad desde el diseño.' },
      { title: 'QA y Pruebas Automatizadas', description: 'Estrategias de testing que garantizan calidad continua y despliegues confiables.' },
    ])
  }, [])
  return <section className="services">
    {serviceList.map((service, index) => <div
      key={'services' + index}
      className='service_list'
    >
      <h2>{service.title}</h2>
      <h3>{service.description}</h3>
    </div>)}
  </section>
}